import { Header } from "@/components/site/Header";
import { FeaturedProducts } from "@/components/site/FeaturedProducts";
import { CategoryShowcase } from "@/components/site/CategoryShowcase";
import { FastShopping } from "@/components/site/FastShopping";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Tracking } from "@/components/site/Tracking";
import { Testimonials } from "@/components/site/Testimonials";
import { Partners } from "@/components/site/Partners";
import { Blog } from "@/components/site/Blog";
import { Footer } from "@/components/site/Footer";
import { useCatalog } from "@/lib/useCatalog";
import { Seo } from "@/components/seo/Seo";
import { organizationLd, websiteLd } from "@/components/seo/jsonld";

export const Home = ({ cartCount, onAdd }) => {
  const { catalog, featured, loading } = useCatalog();

  return (
    <div data-loading={loading ? "true" : "false"}>
      <Seo
        title="Wholesale Aesthetic Supplies — Korean Fillers, Botox & Biostimulators"
        description="Buy Korean fillers, botulinum toxin, biostimulators & skin boosters wholesale at Discount Fillers. Volume pricing 5+ units, cold-chain shipping, clinic pricing."
        keywords="wholesale aesthetic supplies, buy Korean fillers, cheap botulinum toxin, clinic wholesale, MOQ 5 units, cold-chain fillers, Botulax Nabota Meditoxin wholesale, Restylane Juvederm alternatives, Sculptra Radiesse bulk pricing"
        path="/"
        jsonLd={[organizationLd(), websiteLd()]}
      />
      <Header cartCount={cartCount} />
      <main className="pt-28 md:pt-32">
        {/* Single canonical H1 for SEO — visually hidden but read by crawlers & screen readers */}
        <h1 className="sr-only" data-testid="home-h1">
          Discount Fillers — Wholesale Aesthetic Supplies at Unbeatable Prices
        </h1>
        <FeaturedProducts products={featured} onAdd={onAdd} />
        <CategoryShowcase catalog={catalog} onAdd={onAdd} />
        <FastShopping />
        <HowItWorks />
        <Tracking />
        <Testimonials />
        <Partners />
        <Blog />
      </main>
      <Footer />
    </div>
  );
};
